export default "__VITE_ASSET__BPpb$7ql__"